import { assetUrl as appAssetUrl } from '../app-path.js';
const extremeAlertsModal = () => {
  const triggerSelector = '[data-extreme-alert-trigger]'
  const overlaySelector = '[data-extreme-alert-overlay]'
  const closeSelector = '[data-extreme-alert-close]'
  const listSelector = '[data-extreme-alert-list]'
  const emptySelector = '[data-extreme-alert-empty]'
  const containerSelector = '.extreme-alert-modal__container'
  const activeClass = '-active'
  const alertIconPath = appAssetUrl('/dist/images/v2/svg/day-alert-2026.svg')
  const dataLayerId = 'Modal_Warning-TemperatureChange'
  const globalFlag = '__extremeAlertsModalBound__'
  let isInitialized = false
  const isGlobalBound = () => typeof window !== 'undefined' && window[globalFlag]
  const setGlobalBound = () => {
    if (typeof window !== 'undefined') window[globalFlag] = true
  }

  const pushDataLayerEvent = (eventName) => {
    if (!eventName) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, id: dataLayerId })
  }

  const parseNumber = (value) => {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
  }

  const getOverlay = (trigger) => {
    const targetId = trigger && trigger.dataset ? trigger.dataset.extremeAlertTrigger : null
    if (targetId) return document.getElementById(targetId)
    return document.querySelector(`${overlaySelector}.${activeClass}`) || document.querySelector(overlaySelector)
  }

  const closeModal = (overlay) => {
    const modalOverlay = overlay || getOverlay()
    if (!modalOverlay || !modalOverlay.classList.contains(activeClass)) return

    modalOverlay.classList.remove(activeClass)
    document.body.classList.remove('_overflow-hidden')
    pushDataLayerEvent('close_element')
  }

  const openModal = (overlay) => {
    if (!overlay || overlay.classList.contains(activeClass)) return

    overlay.classList.add(activeClass)
    document.body.classList.add('_overflow-hidden')
    pushDataLayerEvent('open_element')
  }

  const getCityName = (trigger, overlay) => {
    const dataCity = trigger && trigger.dataset ? trigger.dataset.alertCity : ''
    const overlayCity = overlay && overlay.dataset ? overlay.dataset.alertCity : ''
    const pageCity = window.pageData && window.pageData.infoCity ? window.pageData.infoCity.city : ''

    return dataCity || overlayCity || pageCity || ''
  }

  const getHumidityValue = (min, max) => {
    if (min !== null && max !== null) return Math.min(min, max)
    if (min !== null) return min
    if (max !== null) return max
    return null
  }

  const buildAlerts = (trigger, overlay) => {
    const precipitation = parseNumber(trigger.dataset.alertPrecipitation)
    const wind = parseNumber(trigger.dataset.alertWind)
    const humidityMin = parseNumber(trigger.dataset.alertHumidityMin)
    const humidityMax = parseNumber(trigger.dataset.alertHumidityMax)
    const tempMin = parseNumber(trigger.dataset.alertTempMin)
    const tempMax = parseNumber(trigger.dataset.alertTempMax)
    const cityName = getCityName(trigger, overlay)

    const alerts = []

    if (precipitation !== null && precipitation >= 50) {
      alerts.push({
        title: 'Aviso de Chuva',
        criteria: 'Muito forte - acima de 50 mm',
        text: `A previsão indica chuva volumosa para o dia na cidade ${cityName}, com valores iguais ou superiores a 50 mm.`
      })
    }

    if (wind !== null && wind >= 50) {
      alerts.push({
        title: 'Aviso de Vento',
        criteria: 'Valor igual ou superior a 50 km/h',
        text: `A previsão indica períodos de ventos fortes para o dia na cidade ${cityName}, com valores iguais ou superiores a 50 km/h.`
      })
    }

    const humidityValue = getHumidityValue(humidityMin, humidityMax)
    if (humidityValue !== null && humidityValue <= 30) {
      alerts.push({
        title: 'Aviso de Umidade',
        criteria: 'Valor menor ou igual a 30%',
        text: `A previsão indica baixa umidade relativa do ar para o dia na cidade ${cityName}, com valores iguais ou inferiores a 30%.`
      })
    }

    if (tempMin !== null && tempMin <= 10) {
      alerts.push({
        title: 'Aviso de Temperatura',
        criteria: 'Valor menor ou igual a 10°C',
        text: `A previsão indica temperatura muito baixa para o dia na cidade ${cityName}, com valores iguais ou inferiores a 10°C.`
      })
    }

    if (tempMax !== null && tempMax >= 35) {
      alerts.push({
        title: 'Aviso de Temperatura',
        criteria: 'Valor igual ou superior a 35°C',
        text: `A previsão indica temperatura muito alta para o dia na cidade ${cityName}, com valores iguais ou superiores a 35°C.`
      })
    }

    return alerts
  }

  const renderAlerts = (alerts, overlay) => {
    const list = overlay.querySelector(listSelector)
    const emptyState = overlay.querySelector(emptySelector)

    if (!list) return

    list.innerHTML = ''

    alerts.forEach((alert) => {
      const item = document.createElement('div')
      item.className = 'extreme-alert-modal__item'

      const icon = document.createElement('img')
      icon.className = 'extreme-alert-modal__item-icon'
      icon.src = alertIconPath
      icon.alt = ''

      const content = document.createElement('div')
      content.className = 'extreme-alert-modal__item-content'

      const title = document.createElement('p')
      title.className = 'extreme-alert-modal__item-title'
      title.textContent = alert.title

      const criteria = document.createElement('p')
      criteria.className = 'extreme-alert-modal__item-criteria'
      criteria.textContent = alert.criteria

      const text = document.createElement('p')
      text.className = 'extreme-alert-modal__item-text'
      text.textContent = alert.text

      content.appendChild(title)
      content.appendChild(criteria)
      content.appendChild(text)

      item.appendChild(icon)
      item.appendChild(content)
      list.appendChild(item)
    })

    if (emptyState) emptyState.style.display = alerts.length ? 'none' : 'block'
  }

  const bindTriggers = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(triggerSelector)
      if (!trigger) return

      const overlay = getOverlay(trigger)
      if (!overlay) return

      const alerts = buildAlerts(trigger, overlay)
      if (!alerts.length) return

      renderAlerts(alerts, overlay)
      openModal(overlay)
    })
  }

  const bindCloseActions = () => {
    document.addEventListener('click', (event) => {
      const overlay = event.target.closest(overlaySelector)
      if (!overlay) return

      const isClose = event.target.matches(closeSelector) || event.target.closest(closeSelector)
      if (isClose) {
        event.preventDefault()
        closeModal(overlay)
        return
      }

      const isInsideContainer = event.target.closest(containerSelector)
      if (isInsideContainer) return

      event.preventDefault()
      closeModal(overlay)
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal()
    })
  }

  const init = () => {
    if (isGlobalBound()) return
    if (isInitialized) return
    const overlay = document.querySelector(overlaySelector)
    const trigger = document.querySelector(triggerSelector)

    if (!overlay || !trigger) return

    isInitialized = true
    setGlobalBound()
    bindTriggers()
    bindCloseActions()
  }

  return { init }
}

export default extremeAlertsModal()
